
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const MaterialComparison = () => {
  const comparisons = [
    {
      material: "Asphalt Shingles",
      lifespan: "20-30 years",
      cost: "$",
      maintenance: "Low",
      energy: "Standard",
      climate: "Excellent",
      warranty: "25-30 years",
      bestFor: "Residential homes, budget-conscious projects"
    },
    {
      material: "Metal Roofing",
      lifespan: "40-70 years",
      cost: "$$",
      maintenance: "Very Low",
      energy: "Excellent",
      climate: "Superior",
      warranty: "30-50 years",
      bestFor: "Long-term investment, energy efficiency"
    },
    {
      material: "TPO Membrane",
      lifespan: "15-20 years",
      cost: "$",
      maintenance: "Low",
      energy: "Very Good",
      climate: "Good",
      warranty: "15-20 years",
      bestFor: "Commercial flat roofs, cost-effective"
    },
    {
      material: "EPDM Rubber",
      lifespan: "20-25 years",
      cost: "$$",
      maintenance: "Low",
      energy: "Good",
      climate: "Excellent",
      warranty: "20-25 years",
      bestFor: "Commercial buildings, proven performance"
    }
  ];

  const getCostColor = (cost: string) => {
    switch (cost) {
      case "$": return "bg-green-100 text-green-800";
      case "$$": return "bg-yellow-100 text-yellow-800";
      case "$$$": return "bg-red-100 text-red-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  const getPerformanceColor = (rating: string) => {
    switch (rating) {
      case "Excellent":
      case "Superior":
        return "bg-green-100 text-green-800";
      case "Very Good":
        return "bg-blue-100 text-blue-800";
      case "Good":
        return "bg-yellow-100 text-yellow-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4">Material Comparison Guide</h2>
          <p className="text-lg text-gray-600">
            Compare key characteristics to choose the best roofing material for your specific needs and budget.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {comparisons.map((item, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="text-lg text-center">{item.material}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Lifespan:</span>
                  <span className="text-sm">{item.lifespan}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Cost:</span>
                  <Badge className={getCostColor(item.cost)}>{item.cost}</Badge>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Maintenance:</span>
                  <Badge className={getPerformanceColor(item.maintenance)}>{item.maintenance}</Badge>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Energy Efficiency:</span>
                  <Badge className={getPerformanceColor(item.energy)}>{item.energy}</Badge>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Climate Resistance:</span>
                  <Badge className={getPerformanceColor(item.climate)}>{item.climate}</Badge>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Warranty:</span>
                  <span className="text-sm">{item.warranty}</span>
                </div>
                <div className="pt-2 border-t">
                  <p className="text-xs text-gray-600">
                    <span className="font-medium">Best for:</span> {item.bestFor}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MaterialComparison;
